import { enableBodyScroll, disableBodyScroll } from 'body-scroll-lock';

import AbstractComponent from './AbstractComponent';

export default class MobileMenu extends AbstractComponent {
  /**
   * The HTML element of the hamburger icon button in the header.
   */
  private $toggleButton: HTMLButtonElement;

  /**
   * The HTML element of the mobile menu.
   */
  private $mobileMenu: HTMLElement;

  /**
   * The HTML element of the header.
   */
  private $header: HTMLElement;

  /**
   * Flag to indicate whether the mobile menu is open or not.
   */
  private isOpened: boolean = false;

  /**
   * Initializes the mobile menu.
   */
  public initialize(): void {
    this.$toggleButton = document.querySelector('.header__menu-toggle');
    this.$mobileMenu = document.querySelector('.mobile-menu');
    this.$header = document.querySelector('.header');

    this.$toggleButton.addEventListener('click', (event) => this.onToggleButtonClicked(event));
  }

  public onWindowResize(lastSize: { width: number, height: number }): void {
    if (
      lastSize.width < AbstractComponent.BREAKPOINT_MD
      && window.innerWidth >= AbstractComponent.BREAKPOINT_MD
    ) {
      if (this.isOpened) {
        enableBodyScroll(this.$mobileMenu);
      }
    }

    if (
      lastSize.width >= AbstractComponent.BREAKPOINT_MD
      && window.innerWidth < AbstractComponent.BREAKPOINT_MD
    ) {
      if (this.isOpened) {
        disableBodyScroll(this.$mobileMenu);
      }
    }
  }

  /**
   * Called when the user clicks on the hamburger menu icon in the header.
   *
   * @param event The event arguments
   */
  private onToggleButtonClicked(event: MouseEvent): void {
    event.preventDefault();

    this.isOpened = !this.isOpened;

    this.$mobileMenu.classList.toggle('is-opened');
    this.$header.classList.toggle('is-opened');

    if (this.isOpened) {
      disableBodyScroll(this.$mobileMenu);
    } else {
      enableBodyScroll(this.$mobileMenu);
    }
  }
}
